import { render } from "./index.vue?vue&type=template&id=51a0a016&scoped=true&bindings={}"
import script from "./create-playlist.js?vue&type=script&lang=js"
export * from "./create-playlist.js?vue&type=script&lang=js"

import "./create-playlist.scss?vue&type=style&index=0&id=51a0a016&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-51a0a016"

export default script